
import React from 'react';

interface SegmentedControlProps {
  label: string;
  options: { id: string; label: string; disabled?: boolean }[];
  current: string;
  onChange: (id: any) => void;
}

export const SegmentedControl: React.FC<SegmentedControlProps> = ({ label, options, current, onChange }) => (
  <div className="space-y-2">
    <label className="text-[10px] font-black uppercase tracking-widest text-slate-400 block">{label}</label>
    <div className="flex gap-2 p-1 bg-slate-950 rounded-xl border border-slate-800">
      {options.map(opt => (
        <button
          key={opt.id}
          disabled={opt.disabled}
          onClick={() => onChange(opt.id)}
          className={`flex-1 py-2 rounded-lg text-xs font-bold transition-all ${
            opt.disabled 
              ? 'opacity-20 cursor-not-allowed text-slate-700' 
              : current === opt.id 
                ? 'bg-indigo-600 text-white shadow-lg shadow-indigo-500/20' 
                : 'text-slate-500 hover:text-slate-300'
          }`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  </div>
);

interface RangeControlProps {
  label: string;
  value: number;
  min: number;
  max: number;
  onChange: (val: number) => void;
  colorClass: string;
}

export const RangeControl: React.FC<RangeControlProps> = ({ label, value, min, max, onChange, colorClass }) => (
  <div className="space-y-2">
    <div className="flex justify-between items-center">
      <label className="text-[10px] font-black uppercase tracking-widest text-slate-400 block">{label}</label>
      <span className="text-[10px] font-bold text-slate-500">{value}px</span>
    </div>
    <input 
      type="range" 
      min={min} 
      max={max} 
      value={value} 
      onChange={e => onChange(parseInt(e.target.value))} 
      className={`w-full h-1.5 bg-slate-800 rounded-lg appearance-none cursor-pointer ${colorClass}`} 
    />
  </div>
);
